export const color = '#0B1222'
export const text = `white`